import { AppBundle } from 'src/api/optimalprint-sdk.d';
import { BundledProduct } from 'src/store/productBundle/types';
import { IntegrationLayer } from 'src/types.d';

type ProductItem = AppBundle.Api.Entity.App.V1.AbstractProduct.ProductItem;

const getAllProducts = (integrationLayer: IntegrationLayer) => (
  (integrationLayer.abstractProduct && integrationLayer.abstractProduct.products as any[] as ProductItem[]) || []
);

/**
 * Finds a bundled product by its productUid and returns the corresponding BundledProduct
 * with bundleGroupId and productId.
 */
const findBundledProductByUid = (
  productUid: string,
  integrationLayer: IntegrationLayer,
): BundledProduct | null => {
  let result: BundledProduct | null = null;

  getAllProducts(integrationLayer).find((product) => product.bundleGroups?.some(
    (bundledGroup) => bundledGroup.items?.find((item) => {
      if (item.productUid === productUid) {
        result = {
          bundleGroupId: bundledGroup.bundleGroupId,
          productId: item.productId,
        };
        return true;
      }
      return false;
    }),
  ));

  return result;
};

/**
 * Converts bundledProducts from AOV event format (object with UIDs as keys)
 * to the Redux store format (array of BundledProduct with bundleGroupId and productId).
 *
 * @param bundledProducts - Object from AOV event like { "frame_uid": "frame_uid" } or empty {}
 * @returns Array of BundledProduct for Redux store
 */
const resolveBundledProductsFromUids = (
  bundledProducts: Record<string, string> | BundledProduct[],
): BundledProduct[] => {
  const { integrationLayer } = window;

  // If already in correct format (array), return as is
  if (Array.isArray(bundledProducts)) {
    return bundledProducts;
  }

  // If empty object or not an object, return empty array
  if (!bundledProducts || typeof bundledProducts !== 'object') {
    return [];
  }

  const result: BundledProduct[] = [];
  const productUids = Object.keys(bundledProducts);

  productUids.forEach((productUid) => {
    const bundledProduct = findBundledProductByUid(productUid, integrationLayer);
    if (bundledProduct) {
      result.push(bundledProduct);
    }
  });

  return result;
};

export default resolveBundledProductsFromUids;
